document.addEventListener('DOMContentLoaded', function() {
  class SizeguideDrawer extends HTMLElement {
    constructor() {
      super();
      // Gestire la chiusura con il tasto Escape
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      // Gestire la chiusura con il click sull'overlay
      this.querySelector('.drawer__close').addEventListener('click', this.close.bind(this));
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // Inizializzare gli event listener sull'icona di ricerca
      this.initSizeguideIconListeners();
    }

    initSizeguideIconListeners() {
      // Trovare tutte le icone di ricerca e assegnare l'event listener
      const sizeguideIcons = document.querySelectorAll('[id*="sizeguideIcon"]');
      sizeguideIcons.forEach((icon) => {
        icon.addEventListener('click', this.open.bind(this));
      });
    }

    open() {
      const sizeguideDrawer = document.getElementById('SizeguideDrawer');
      // Aggiungere le classi animate e active
      setTimeout(() => { sizeguideDrawer.classList.add('animate', 'active'); });

      sizeguideDrawer.addEventListener('transitionend', () => {
        const focusElement = sizeguideDrawer.querySelector('.drawer__inner') || sizeguideDrawer.querySelector('.drawer__close');
        trapFocus(sizeguideDrawer, focusElement);
      }, { once: true });

      // Prevenire lo scrolling del body
      document.body.style.paddingRight = this.getScrollbarWidth() + 'px';
   /*   document.body.classList.add('overflow-hidden'); */
    }

    close() {
      const sizeguideDrawer = document.getElementById('SizeguideDrawer');
      sizeguideDrawer.classList.remove('active');
      removeTrapFocus(this.activeElement);
   /*   document.body.classList.remove('overflow-hidden'); */
      document.body.style.paddingRight = '';
    }

    getScrollbarWidth() {
      return window.innerWidth - document.documentElement.clientWidth;
    }
  }

  customElements.define('sizeguide-drawer', SizeguideDrawer);
});

// Assicurati che le funzioni trapFocus e removeTrapFocus siano definite altrove nel tuo script.


// seleziona l'elemento con la classe "tabella-misure"
const tabellaMisure = document.querySelector('.tabella-misure');








// Initialize both sliders
const swiperMisura = new Swiper('#slider-tabella-misura', {
  // Optional parameters

	loop: false,

	 // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },

 
	slidesPerView: 2.5,
	slidesPerView: 3.4,
	centeredSlides: false,
  breakpoints: {
          0: { 
            slidesPerView: 3.4,
             },
          390: {
            slidesPerView: 2.58,
	slidesPerView: 3.5,
            observer: true, // Attiva l'osservatore per ricalcolare le slide visibili
          observeParents: true, // Attiva l'osservatore per ricalcolare le slide visibili
         on: {
            resize: function () {
              this.update(); // Aggiorna lo slider quando la dimensione del contenitore cambia
              this.slideTo(this.slides.length - this.params.slidesPerView); // Posiziona la slide finale sul bordo destro
            },
          },
          },
  768: { 
            slidesPerView: 4.4,
             },
        },
  
});

const swiperMisura2 = new Swiper('#slider-tabella-misura-2', {
  // Optional parameters

	loop: false,

	 // And if we need scrollbar
  scrollbar: {
    el: '.swiper-scrollbar',
  },
	slidesPerView: 2.5,
	slidesPerView: 3.4,
	centeredSlides: false,

    breakpoints: {
  768: { 
        slidesPerView: "auto",
         },
    },
});



document.getElementById("btn-cm").addEventListener("click", function() {
    document.getElementById("table-cm").style.display = "block";
    document.getElementById("table-inc").style.display = "none";
  });

  document.getElementById("btn-inc").addEventListener("click", function() {
    document.getElementById("table-cm").style.display = "none";
    document.getElementById("table-inc").style.display = "block";
  });

document.getElementById("btn-cm").addEventListener("click", function() {
    document.getElementById("table-mobile-cm").style.display = "block";
    document.getElementById("table-mobile-inc").style.display = "none";
  });

  document.getElementById("btn-inc").addEventListener("click", function() {
    document.getElementById("table-mobile-cm").style.display = "none";
    document.getElementById("table-mobile-inc").style.display = "block";
  });




// Ottieni i riferimenti ai pulsanti
var btnCm = document.getElementById("btn-cm");
var btnInc = document.getElementById("btn-inc");

// Aggiungi la classe "table-active" a btn-cm
btnCm.classList.add("table-active");

// Aggiungi gli event listener ai pulsanti
btnCm.addEventListener("click", toggleActiveClass);
btnInc.addEventListener("click", toggleActiveClass);

function toggleActiveClass() {
  // Controlla quale pulsante è stato cliccato
  if (this === btnCm) {
    // Rimuovi la classe "table-active" da btn-cm e aggiungila a btn-inc
    btnCm.classList.add("table-active");
    btnInc.classList.remove("table-active");
  } else if (this === btnInc) {
    // Controlla se btn-cm ha la classe "table-active"
    if (btnCm.classList.contains("table-active")) {
      // Rimuovi la classe "table-active" da btn-cm e aggiungila a btn-inc
      btnCm.classList.remove("table-active");
      btnInc.classList.add("table-active");
    } else {
      // Rimuovi la classe "table-active" da btn-inc e aggiungila a btn-cm
      btnInc.classList.remove("table-active");
      btnCm.classList.add("table-active");
    }
  }
}

